<template>
  <v-card class="mb-2" flat v-if="participantes && participantes.length > 0">
    <v-row>
      <v-col cols="6" class="pb-0">
        <span class="primary--text text-subtitle-1 font-weight-medium">
          {{ titulo }}
        </span>
      </v-col>
      <v-col
        v-if="
          participantes &&
          participantes.some(
            (p) => p.EstadoCivil === $aux.EstadoCivilEnum.Casado
          )
        "
        cols="6"
        class="pb-0"
      >
        <span class="primary--text text-subtitle-1 font-weight-medium">
          {{ tituloConjuge }}
        </span>
      </v-col>
    </v-row>
    <v-row v-for="(item, i) in participantes" :key="i">
      <v-col cols="6">
        <PropostaAssinantePapelItem
          :proposta="proposta"
          :tipo="tipo"
          :nome="item.Nome"
          :documento="item.Documento"
          v-model="item.Papeis"
          :opcional="item.Opcional"
          :active="item.MostrarCCB"
          @hasChanges="(p) => (item.HasChanges = p)"
          @activated="(p) => (item.MostrarCCB = p)"
          :show-papeis="showPapeis"
          :listDocFederalGarantia="listDocFederalGarantia"
        />
      </v-col>
      <v-col cols="6" v-if="item.EstadoCivil === $aux.EstadoCivilEnum.Casado">
        <PropostaAssinantePapelItem
          conjuge
          :proposta="proposta"
          :tipo="tipo"
          :nome="item.Nome"
          :documento="item.Documento"
          :nomeConjuge="item.NomeConjuge"
          :documentoConjuge="item.DocumentoConjuge"
          v-model="item.PapeisConjuge"
          :opcional="item.OpcionalConjuge"
          :active="item.MostrarCCBConjuge"
          @hasChanges="(p) => (item.HasChangesConjuge = p)"
          @activated="(p) => (item.MostrarCCBConjuge = p)"
          :show-papeis="showPapeis"
          :listDocFederalGarantia="listDocFederalGarantia"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  components: {
    PropostaAssinantePapelItem: () => import('./PropostaAssinantePapelItem.vue'),
  },
  props: {
    showPapeis: { type: Boolean, default: false },
    proposta: null,
    tipo: null,
    participantes: null,
    listDocFederalGarantia: []
  },
  data () {
    return {
      tipoParticipanteCCBEnum: this.$api.Estruturadas.TipoAssinanteEnum,
      model: []
    }
  },
  computed: {
    titulo () {
      switch (this.tipo) {
        case this.tipoParticipanteCCBEnum.Emitente:
          return 'Emitente'
        case this.tipoParticipanteCCBEnum.Socio:
          return 'Sócios'
        case this.tipoParticipanteCCBEnum.Avalista:
          return 'Garantidores'
      }

      return ''
    },
    tituloConjuge () {
      switch (this.tipo) {
        case this.tipoParticipanteCCBEnum.Emitente:
          return 'Cônjuge'
        default:
          return 'Cônjuges'
      }
    }
  },
}
</script>
